import { definePlugin } from "./plugin";
import VueMask from "v-mask";
import Vue from "vue";
import { vMaska } from "maska";

export const MaskaPlugin = definePlugin(() => {
  Vue.use(VueMask);
  Vue.directive("maska", vMaska);
});
